'use strict';

var React = require('react'),
    FormMixin = require('../mixins/FormMixin'),
    FormInputRow = require('../molecules/FormInputRow'),
    Button = require('../atoms/Button'),
    UserActionCreators = require('../actions/UserActionCreators'),
    PureRenderMixin = require('../mixins/PureRenderMixin');

var ResetPassword = React.createClass({
  mixins: [FormMixin, PureRenderMixin],

  propTypes: {
    onCloseClick: React.PropTypes.func.isRequired,
    userId: React.PropTypes.string
  },

  getInitialState: function () {
    return {
      password: '',
      confirmPassword: ''
    };
  },

  componentDidUpdate: function () {
    if (this.isFormSubmitted()) {
      this.props.onCloseClick(true);
    }
  },

  render: function () {
    return (
      <div className='Modal-body'>
        <div className='Modal-header'>
          <h3 className='Modal-title'>
            Reset Password
          </h3>
        </div>
        <div className='Modal-content'>
          <div className='Form'>
            <FormInputRow label='New Password'
                          type='password'
                          formLink={this.linkValidatedState('password', this.validatePassword)} />
            <FormInputRow label='New Password, Again'
                          type='password'
                          formLink={this.linkValidatedState('confirmPassword', this.validateConfirmPassword)} />
          </div>
        </div>
        {this.renderFooter()}
      </div>
    );
  },

  renderFooter: function () {
    return (
      <div className='Modal-footer'>
        <Button color='green'
                onClick={this.submitForm.bind(this, this.sendRequest)}
                disabled={!this.isFormEditable()}
                size='large'>
          Save
        </Button>
      </div>
    );
  },

  validatePassword: function (password) {
    password = (password || '').trim();

    if (!password) {
      return {
        error: 'Required'
      };
    } else if (password.length < 8) {
      return {
        error: 'Minimum 8 characters'
      };
    }
  },

  validateConfirmPassword: function (confirmPassword) {
    confirmPassword = (confirmPassword || '').trim();

    if (!confirmPassword && !this.state.password) {
      return;
    }

    if (confirmPassword !== this.state.password) {
      return {
        error: 'Password doesn’t match'
      };
    }
  },

  sendRequest: function () {
    var data = {
      password: this.state.password,
      userId: this.props.userId
    };

    UserActionCreators.resetPassword(data);
  }
});

module.exports = ResetPassword;



/** WEBPACK FOOTER **
 ** ./modals/ResetPassword.jsx
 **/